import Superstore, { IndexedDB } from 'superstore';
const storeInstancesMap = new Map();

// Copied from superstore asset bender package

export async function getStorageInstance(namespace, partition) {
  let storeInstance = storeInstancesMap.get(namespace);
  if (!storeInstance) {
    const storeOptions = {
      backend: IndexedDB,
      namespace
    };
    if (partition) {
      const {
        portalId,
        userId
      } = partition;
      storeOptions.partition = () => userId ? `${portalId}.${userId}` : `${portalId}`;
    }
    storeInstance = await new Superstore(storeOptions).open();
    storeInstancesMap.set(namespace, storeInstance);
  }
  return storeInstance;
}
export default getStorageInstance;